// extracted by css-extract-rspack-plugin
export default {"liveTag":"SdXKrZ2P"};